import React, { InputHTMLAttributes } from 'react';
import { Checkbox, CheckboxContainer, FormLabel } from './CheckboxField.styles';

type CheckboxFieldProps = {
  label: string;
  checkboxId: string;
} & InputHTMLAttributes<HTMLInputElement>;

export function CheckboxField(props: CheckboxFieldProps): JSX.Element {
  return (
    <CheckboxContainer>
      <Checkbox id={props.checkboxId} type="checkbox" {...props} />
      <FormLabel htmlFor={props.checkboxId}>{props.label}</FormLabel>
    </CheckboxContainer>
  );
}
